import { Fragment, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchAPI } from '../../api/request';
import Loading from '../../components/common/Loading.component';
import DeleteView from '../../views/Delete.view';
import Alert from '../../components/common/Alert.component';
import _ from 'lodash';

const DeleteTemplate = ({
  module: { tag, remove, query },
  children,
  idDelete,
  isIcon = false,
}) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading: loadingGet } = useSelector(remove.selector.data);
  const [loading, setLoading] = useState(false);
  const { jwt } = useSelector((state) => state.login);
  const [error, setError] = useState(null);
  const userAuth = useSelector((state) => state.login?.user);
  const _query = useSelector(query.all.selector);

  const fetchDataUpdate = useCallback(() => {
    const params = id ? { id } : {};
    dispatch(
      query.all.action({
        settings: query.all.settings,
        token: jwt,
        params,
        query: { ..._query, populate: query.all.populate },
      })
    );
  }, [_query, dispatch, jwt, query, id]);

  const onSuccess = useCallback(() => {
    setLoading(true);
    setError(null);
    if (idDelete) {
      fetchDataUpdate();
    } else {
      navigate(remove?.navigate ? remove?.navigate : -2);
    }
  }, [navigate, setLoading, remove, idDelete, fetchDataUpdate]);

  const onError = useCallback((error) => {
    setLoading(false);
    setError(error);
    // eslint-disable-next-line
  }, []);

  const onSubmit = useCallback(() => {
    if (userAuth.permissions[_.toUpper(tag)]?.DELETE === 'true') {
      const item = id ? id : idDelete;
      setError(false);
      setLoading(false);
      fetchAPI(query.delete.settings, { id: item }, '', {}, jwt)
        .then(onSuccess)
        .catch((error) => onError(error));
    }
  }, [id, jwt, onError, onSuccess, query, userAuth, tag, idDelete]);

  return (
    userAuth.permissions[_.toUpper(tag)]?.DELETE === 'true' && (
      <Fragment>
        {(loading || loadingGet) && <Loading />}
        {error && (
          <Alert severity='error'>
            {error?.response?.data?.error?.message
              ? error?.response?.data?.error?.message
              : 'An error has occurred'}
          </Alert>
        )}

        {!loadingGet && (
          <DeleteView
            onDeleteSubmit={onSubmit}
            disabled={loading || loadingGet}
            isIcon={isIcon}
          >
            {children}
          </DeleteView>
        )}
      </Fragment>
    )
  );
};

export default DeleteTemplate;
